import { useMutation } from "react-query";
import { deleteAdditionalDiagnosis } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

const useDeleteAdditionalDiagnosis = (options: Record<string, any> = {}) => {
  const { onSuccess = () => {}, onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    (id: number) => deleteAdditionalDiagnosis(id),
    {
      onSuccess: (response, variables) => {
        showToast({ message: "Additional diagnosis deleted successfully." });
        onSuccess(response, variables);
      },
      onError: (error: any) => {
        const errorMessage =
          error?.response?.data?.error || "Failed to delete additional diagnosis";
        showToast({ message: errorMessage, errorState: true });
        onError(error);
      },
      ...otherOptions,
    }
  );

  return {
    deleteAdditionalDiagnosisMutation: mutate,
    isDeleteAdditionalDiagnosisLoading: isLoading,
    ...rest,
  };
};

export default useDeleteAdditionalDiagnosis;
